{
  "names": {
    "Fajr": "ফজর",
    "Dhuhr": "যোহর",
    "Asr": "আসর",
    "Maghrib": "মাগরিব",
    "Isha": "এশা"
  },
  "card": {
    "label": "পরবর্তী নামাজ",
    "labelTomorrow": "আগামীকাল · {{prayer}}",
    "inHoursMinutes": "{{hours}} ঘ {{minutes}} মি বাকি",
    "inMinutes": "{{minutes}} মি বাকি",
    "open_aria": "নামাজের সময় খুলুন",
    "pro": "Rhemn Pro",
    "unlock_aria": "Rhemn Pro দিয়ে নামাজের সময় আনলক করুন",
    "unavailable": "নামাজের সময়সূচি এখন পাওয়া যাচ্ছে না।"
  },
  "sheet": {
    "bellOn_aria": "{{prayer}} অনুস্মারক বন্ধ করুন",
    "bellOff_aria": "{{prayer}} অনুস্মারক চালু করুন",
    "explainer": "প্রতি নামাজে মৃদু অনুস্মারক পান। অনুস্মারকগুলো নীরব নোটিফিকেশন — ডিফল্টভাবে কোনো শব্দ নেই।",
    "enableReminders": "অনুস্মারক চালু করুন",
    "enableInSettings": "নামাজের অনুস্মারক পেতে সেটিংসে Rhemn-এর নোটিফিকেশন চালু করুন।",
    "openSettings": "সেটিংস খুলুন"
  },
  "notifications": {
    "body": "নামাজের সময় হয়েছে।"
  },
  "focus": {
    "label": "{{prayer}} নামাজ",
    "close_aria": "নামাজের স্ক্রিন বন্ধ করুন",
    "hint": "ফিরে যেতে Esc বা × চাপুন",
    "phrases": {
      "accepted": "আল্লাহ আপনার নামাজ কবুল করুন",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "নিয়ত দিয়ে শুরু করুন। বরকতের সাথে চালিয়ে যান।",
    "prayerApproaches": "আপনার পরবর্তী নামাজ এগিয়ে আসছে। আপনার নিয়তে স্থির থাকুন।",
    "morningPursue": "অনুসরণ করার জন্য একটি বরকতময় সকাল: {{focus}}",
    "dayCloses": "দিন যখন শেষ হচ্ছে, ভাবুন: {{focus}}",
    "fulfilled": "আপনি আজ আপনার নিয়ত পূর্ণ করেছেন। আলহামদুলিল্লাহ।",
    "workingTowards": "আজ আপনি কাজ করছেন: {{focus}}",
    "prayerNear": "আপনার পরবর্তী নামাজ নিকটে। একটু শ্বাস নিন।"
  },
  "widget": {
    "countdown": "{{time}} পরে",
    "openToUpdate": "আপডেট করতে Rhemn খুলুন",
    "openForVerse": "আজকের আয়াতের জন্য Rhemn খুলুন"
  }
}
